import { MAP_UNIT_DESCRIPTION, MINOR_COMPONENTS } from './mapUnitDescription';
import {
  PERCENT_CLAY_ALL_LAYERS,
  PERCENT_CLAY_SURFACE_LAYER,
  PERCENT_SAND_ALL_LAYERS,
  PERCENT_SAND_SURFACE_LAYER,
  PERCENT_SILT_ALL_LAYERS,
  PERCENT_SILT_SURFACE_LAYER,
} from './percentX';
import {
  WATER_STORAGE_ALL_LAYERS,
  WATER_STORAGE_SURFACE_LAYER,
} from './availableWaterStorage';
import {
  BULK_DENSITY_ALL_LAYERS,
  BULK_DENSITY_SURFACE_LAYER,
} from './bulkDensity';
import { K_FACTOR_ALL_LAYERS, K_FACTOR_SURFACE_LAYER } from './kFactor';
import { PH_ALL_LAYERS, PH_SURFACE_LAYER } from './phOneToOneWater';
import {
  CATION_EXCHANGE_ALL_LAYERS,
  CATION_EXCHANGE_SURFACE_LAYER,
} from './cationExchangeCapacity';
import {
  ORGANIC_MATTER_ALL_LAYERS,
  ORGANIC_MATTER_SURFACE_LAYER,
} from './soilHealthOrganicMatter';
import { DEPTH_TO_BEDROCK } from './depthToBedrock';
import {
  DEPTH_TO_ANY_RESTRICTIVE_LAYER,
  DEPTH_TO_RESTRICTIVE_LAYER_DENSIC,
  DEPTH_TO_RESTRICTIVE_LAYER_FRAGIPAN,
} from './depthToRestrictiveLayer';
import { T_FACTOR } from './tFactor';
import { FARMLAND_CLASSIFICATION } from './farmlandClassification';
import { PONDING_FREQUENCY_CLASS } from './pondingFrequencyClass';
import { FORESTLAND_PRODUCTIVITY } from './forestlandProductivity';
import { HYDROLOGIC_SOIL_GROUP } from './hydrologicSoilGroup';
import { FLOODING_FREQUENCY_CLASS } from './floodingFrequencyClass';
import { DRAINAGE_CLASS } from './drainageClass';
import { FROST_ACTION } from './frostAction';
import { DEPTH_TO_WATER_TABLE } from './depthToWaterTable';
import { REPRESENTATIVE_SLOPE } from './representativeSlope';
import { SURFACE_TEXTURE } from './soilHealthSurfaceTexture';
import { SUSCEPTIBILITY_TO_COMPACTION } from './susceptibilityToCompaction';
import { DROUGHT_VULNERABLE_SOILS } from './droughtVulnerableSoils';
import { MECH_SITE_PREP_DEEP } from './mechSitePrepDeep';
import { MECH_SITE_PREP_SURFACE } from './mechSitePrepSurface';
import { SUITABILITY_HAND_PLANTING } from './suitabilityHandPlanting';
import { SUITABILITY_MECH_PLANTING } from './suitabilityMechPlanting';
import { NCCPI } from './nccpi';
import { HYDRIC_RATING } from './hydricRating';
import { SoilAttribute } from '../../types/soilAttributes';

export const SOIL_ATTRIBUTES = [
  { options: [MAP_UNIT_DESCRIPTION, MINOR_COMPONENTS] },
  {
    header: 'Physical Soil Composition',
    options: [
      SURFACE_TEXTURE,
      PERCENT_CLAY_SURFACE_LAYER,
      PERCENT_SAND_SURFACE_LAYER,
      PERCENT_SILT_SURFACE_LAYER,
      PERCENT_CLAY_ALL_LAYERS,
      PERCENT_SAND_ALL_LAYERS,
      PERCENT_SILT_ALL_LAYERS,
    ],
  },
  {
    header: 'Agronomic Attributes',
    options: [
      ORGANIC_MATTER_SURFACE_LAYER,
      ORGANIC_MATTER_ALL_LAYERS,
      PH_SURFACE_LAYER,
      PH_ALL_LAYERS,
      CATION_EXCHANGE_SURFACE_LAYER,
      CATION_EXCHANGE_ALL_LAYERS,
      BULK_DENSITY_SURFACE_LAYER,
      BULK_DENSITY_ALL_LAYERS,
    ],
  },
  {
    header: 'Restrictive Layers',
    options: [
      DEPTH_TO_ANY_RESTRICTIVE_LAYER,
      DEPTH_TO_BEDROCK,
      DEPTH_TO_RESTRICTIVE_LAYER_FRAGIPAN,
      DEPTH_TO_RESTRICTIVE_LAYER_DENSIC,
    ],
  },
  {
    header: 'Hydrology',
    options: [
      DEPTH_TO_WATER_TABLE,
      DRAINAGE_CLASS,
      FLOODING_FREQUENCY_CLASS,
      PONDING_FREQUENCY_CLASS,
      DROUGHT_VULNERABLE_SOILS,
      HYDRIC_RATING,
      HYDROLOGIC_SOIL_GROUP,
      FROST_ACTION,
      WATER_STORAGE_SURFACE_LAYER,
      WATER_STORAGE_ALL_LAYERS,
    ],
  },
  {
    header: 'Erosion',
    options: [T_FACTOR, K_FACTOR_SURFACE_LAYER, K_FACTOR_ALL_LAYERS],
  },
  {
    header: 'Equipment Usability',
    options: [
      SUSCEPTIBILITY_TO_COMPACTION,
      MECH_SITE_PREP_SURFACE,
      MECH_SITE_PREP_DEEP,
      SUITABILITY_HAND_PLANTING,
      SUITABILITY_MECH_PLANTING,
      REPRESENTATIVE_SLOPE,
    ],
  },
  {
    header: 'Site Productivity',
    options: [FARMLAND_CLASSIFICATION, NCCPI, FORESTLAND_PRODUCTIVITY],
  },
  // Add more soil attributes here...
] as { options: SoilAttribute[]; header?: string }[];
